Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.flattenArray = flattenArray;
exports.has = void 0;
function flattenArray(array) {
    if (!Array.isArray(array)) {
        return [
            array
        ];
    }
    var resultArr = [];
    var _flattenArray = function _flattenArray(arr) {
        arr.forEach(function(item) {
            if (Array.isArray(item)) {
                _flattenArray(item);
            } else {
                resultArr.push(item);
            }
        });
    };
    _flattenArray(array);
    return resultArr;
}
var has = exports.has = function has(key, x) {
    if (typeof x === "function" || typeof x === "object") {
        if (x === null || x === undefined) {
            return false;
        } else {
            return key in x;
        }
    }
    return false;
};
